<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        :items="availableFarms"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="false"
                        headlineKey="description"
                        v-model="selectedFarmID"
                        filterLabel="Filter Farms"
                >
                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createFarmShow = !createFarmShow"
                        >
                            <v-icon left>mdi-tractor</v-icon>
                            Add Farm
                        </v-btn>
                    </div>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedFarm">
                <v-card>
                    <ModifyFarm :edit-farm="selectedFarm" @save="upsertFarm($event)"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createFarmShow"
                    v-model="createFarmShow"
                    :width="400"
                    persistent
            >
                <v-card>
                    <ModifyFarm :edit-farm="createFarmObj" @dismiss="createFarmShow = !createFarmShow" @save="upsertFarm($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyFarm from "./ModifyFarm";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";

export default {
    components: {Divider, ModifyFarm, MultiSelectList},
    props: {},
    data() {
        return {
            selectedFarmID: null,
            createFarmObj: null,
            createFarmShow: false,
        }
    },
    watch: {
        createFarmShow(val) {
            if (val)
                this.createFarmObj = {
                    id: null,
                    description: null
                }
        }
    },
    methods: {
        async upsertFarm(event) {
            let {farm, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/farm`, farm)
                const addedFarmID = (await waitForEvent(eventID)).farms.pop().id
                this.createFarmShow = false
                this.selectedFarmID = addedFarmID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }

    },
    computed: {
        ...mapGetters(['farms', 'availableFarms']),
        selectedFarm() {
            if (!this.selectedFarmID)
                return null
            return this.farms.filter(obj => obj.id === this.selectedFarmID).pop()
        }
    },
}
</script>

<style scoped>

</style>